import React from "react";
import { PageHeader } from "./PageHeader"
import { DataBox } from "./DataBox"
import { DispatchDrawer } from "./DispatchDrawer"
import { LogDrawer } from "./logDrawer";
import { ApprovalModal } from "./checkAcceptModel";
import { ReportDrawer } from "./reportDrawer";
export default () => {
    return (
        <>
            <PageHeader />
            <DataBox />
            <DispatchDrawer />
            <LogDrawer />
            <ReportDrawer />
            <ApprovalModal />
        </>
    )
}